import { render, staticRenderFns } from "./CarritoCxc.vue?vue&type=template&id=009cec5c&scoped=true"
import script from "./CarritoCxc.vue?vue&type=script&lang=js"
export * from "./CarritoCxc.vue?vue&type=script&lang=js"
import style0 from "./CarritoCxc.vue?vue&type=style&index=0&id=009cec5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009cec5c",
  null
  
)

export default component.exports